
	import Component from 'vue-class-component'
	import moduleStore from './store/realVoiceCustomer';
	import Vue from 'vue';
	import PageState from './store/state';
	import { getQueryString } from '@/utils/location'

	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class realVoiceCustomerPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		qrcodeImage:any = null;
		promottype:any = null;
		realVoiceInfo:Object = {
			info: '添加客服，免费试音',
			tip: '截图或者长按保存二维码',
			tip2: '打开微信扫一扫，添加客服微信',
			btnName: '前往微信添加客服',
		};
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
			// let ww_token = getQueryString("ww_token");
			let from = getQueryString('from')
			if(from=='realVoiceMini'){  //从小程序过来
				this.realVoiceInfo = {
					info: '添加客服，免费试音',
					tip: '长按识别二维码',
					tip2: '添加客服微信',
					btnName: null
				}
			}
		}
		mounted(moduleData:IinjectDatas){	
			this.state.title="这是更改后的title"
			this.state.self = this;
			this.getPic()
		}
		getPic(){
			this.$http('getImage').then(res => {
				this.qrcodeImage = res.data.image;
			})
		}
		toWX(){
			
		}
	}